/**
 * Magnific Popup helpers.
 *
 * Inline modal:
 * <a href="#modal-id" class="polaris-mfp-inline">Open</a>
 * <div id="modal-id" class="polaris-mfp-inline__panel mfp-hide">...</div>
 *
 * Divi Image module (Advanced → CSS Class): polaris-mfp-lightbox
 * Put the video URL on the image link; the first http(s) link inside the module opens in a lightbox iframe (e.g. YouTube).
 */
(function () {
  if (typeof window.jQuery === "undefined") {
    return;
  }

  var $ = window.jQuery;

  function isRemoteHref(href) {
    return typeof href === "string" && /^https?:\/\//i.test(href);
  }

  function initPolarisInlineModals() {
    if (!$.fn.magnificPopup) {
      return;
    }

    $(".polaris-mfp-inline").each(function () {
      var $el = $(this);
      if ($el.data("polarisMfpBound")) {
        return;
      }
      $el.data("polarisMfpBound", true);
      $el.magnificPopup({
        type: "inline",
        midClick: true,
        removalDelay: 160,
        mainClass: "polaris-mfp-inline-wrap",
      });
    });
  }

  function initPolarisDiviImageLightbox() {
    if (!$.fn.magnificPopup) {
      return;
    }

    $(".et_pb_image.polaris-mfp-lightbox").each(function () {
      var $wrap = $(this);
      var $a = $wrap.children("a[href]").first();
      if (!$a.length) {
        $a = $wrap.find("a[href]").first();
      }
      var href = $a.attr("href");
      if (!isRemoteHref(href)) {
        return;
      }
      if ($a.data("polarisMfpLightboxBound")) {
        return;
      }
      $a.data("polarisMfpLightboxBound", true);
      $a.magnificPopup({
        type: "iframe",
        mainClass: "polaris-mfp-iframe-wrap",
      });
    });
  }

  function initPolarisMagnificModals() {
    initPolarisInlineModals();
    initPolarisDiviImageLightbox();
  }

  $(initPolarisMagnificModals);
  document.addEventListener("facetwp-loaded", initPolarisMagnificModals);
})();
